

































import {
  defineComponent, reactive, Ref, ref,
} from '@vue/composition-api';
import PrettyCheck from 'pretty-checkbox-vue/check';

const CommonModalWithReasonSelector = defineComponent({
  components: {
    PrettyCheck,
  },
  props: {
    options: {
      default: () => ([
        { label: '', active: false },
      ]),
    },
  },
  setup(props, { emit }) {
    const modal = ref(null);
    const pendingIndex = ref(-1);
    function compose(index: number) {
      pendingIndex.value = index;
      (modal.value as any).open();
    }
    function close() { (modal.value as any).close(); }

    const _options = reactive(props.options);

    function selectItem(index: number) {
      _options[index].active = !(_options[index].active);
    }

    function doneHandler() {
      emit('done', {
        reason: _options.filter((option: any) => option.active)?.reduce((concatReason: string, option: any) => `${concatReason}${option.label}, `, '') ?? '',
        index: pendingIndex.value,
      });
    }

    return {
      modal,
      compose,
      close,

      _options,
      selectItem,

      doneHandler,
    };
  },
});

export default CommonModalWithReasonSelector;
